var render = function render(){var _vm=this,_c=_vm._self._c;return _c('editor',{attrs:{"id":"tinymce","tag-name":"div","init":_vm.init},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})
}
var staticRenderFns = []

export { render, staticRenderFns }